"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkRoles = checkRoles;

var _knownRoles = require("../../data/knownRoles");

var _formatErrors = _interopRequireDefault(require("../../utilities/formatErrors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
*  Checks Experiment Roles
*  Expected GQL Shape:
*
*    experiment(id: $id) {
      experimentToUsers {
        role {
          id
        }
      }
    }
*/
function checkRoles(experiment) {
  const {
    experimentToUsers
  } = experiment;
  const checks = {};
  Object.values(_knownRoles.KNOWN_ROLES).forEach(({
    isRequired,
    displayName,
    id
  }) => {
    if (isRequired) {
      const enteredRole = experimentToUsers.find(({
        role
      }) => role.id === id);
      checks[`role${id}Required`] = enteredRole ? true : `Please select a ${displayName}`;
    }
  });
  const errors = (0, _formatErrors.default)(checks);
  return {
    checks,
    errors
  };
}